import React from 'react';
import PropTypes from 'prop-types';
// import { FormGroup, Input } from 'reactstrap';
import { FormCheck, FormText } from 'react-bootstrap';
import classNames from 'classnames';

import Label from '../Label';
import { useCheckoutGroupContext } from '../contexts/checkboxContexts';

const CheckboxInput = ({
  name: nameProp,
  label,
  checked: checkedProp,
  value,
  onChange: onChangeProp,
  onBlur,
  required,
  helperText,
  formCheckProps,
}) => {
  const checkboxGroupCtx = useCheckoutGroupContext();

  let checked = checkedProp;
  let name = nameProp;
  let id = name;

  if (checkboxGroupCtx) {
    if (typeof checked === 'undefined') {
      checked = checkboxGroupCtx?.value?.includes(value);
    }
    if (typeof name === 'undefined') {
      name = checkboxGroupCtx.name;
      id = value;
    }
  }

  const onChange = (e) => {
    onChangeProp(e);
    if (checkboxGroupCtx) checkboxGroupCtx.onChange(e);
  };

  return (
    <FormCheck
      id={id}
      className={classNames(
        'custom-control custom-checkbox',
        formCheckProps.className,
      )}
    >
      <FormCheck.Input
        type="checkbox"
        className="custom-control-input"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        onBlur={onBlur}
      />
      <Label
        htmlFor={id}
        check
        required={required}
        className="custom-control-label"
      >
        {label}
      </Label>
      {helperText && <FormText>{helperText}</FormText>}
    </FormCheck>
  );
};

CheckboxInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
    .isRequired,
  value: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  required: PropTypes.bool,
  formCheckProps: PropTypes.shape({
    className: PropTypes.string,
    style: PropTypes.object,
  }),
  helperText: PropTypes.string,
};

CheckboxInput.defaultProps = {
  value: null,
  onChange: () => {},
  onBlur: () => {},
  required: false,
  formCheckProps: {},
};

export default CheckboxInput;
